<div class="main-container">
  <div class="mdl-container">
    <div class="d-grid mdl-header">
      <div class="center-svg"><img src="assets/svg/name-icon.svg" alt=""></div>
      <div>
        <h4 class="text-semibold">Filtrar cuentas</h4>
        <h6 class="color-gray" style="font-weight: 400;">Selecciona los criterios para filtrar la vista de cuentas.</h6>
      </div>
      <div>
        <h3 class="color-gray text-semibold">
          <div class="center-svg">
            <img (click)="closeMdl();" class="close-button" src="assets/svg/close-icon.svg" alt="">
          </div>
        </h3>
      </div>
    </div>

    <form>
      <div class="filter-section">
        <label class="section-title">Propietario de la cuenta</label>
        <div class="filter-options">
          <label class="crm-checkbox-label">
            <input type="checkbox" class="crm-checkbox" [(ngModel)]="filters.allOwners" name="allOwners" (change)="toggleAllOwners()">
            <span class="crm-checkbox-custom"></span>
            Todos los propietarios
          </label>
          <div *ngFor="let owner of availableOwners" class="filter-option-item">
            <label class="crm-checkbox-label">
              <input type="checkbox" class="crm-checkbox" 
                     [(ngModel)]="filters.owners[owner]" 
                     [name]="owner"
                     (change)="onOwnerChange()">
              <span class="crm-checkbox-custom"></span>
              {{ owner }}
            </label>
          </div>
        </div>
      </div>

      <div class="filter-section">
        <label class="section-title">Tipo de cuenta</label>
        <div class="filter-options">
          <label class="crm-checkbox-label">
            <input type="checkbox" class="crm-checkbox" [(ngModel)]="filters.allTypes" name="allTypes" (change)="toggleAllTypes()">
            <span class="crm-checkbox-custom"></span>
            Todos los tipos
          </label>
          <div *ngFor="let type of availableTypes" class="filter-option-item">
            <label class="crm-checkbox-label">
              <input type="checkbox" class="crm-checkbox" 
                     [(ngModel)]="filters.types[type]" 
                     [name]="type"
                     (change)="onTypeChange()">
              <span class="crm-checkbox-custom"></span>
              {{ type }}
            </label>
          </div>
        </div>
      </div>

      <div class="filter-section">
        <label class="section-title">Fecha de creación</label>
        <div class="options-row">
          <label class="crm-radio-label">
            <input type="radio" class="crm-radio" name="creationDateRange" [(ngModel)]="filters.creationDateRange" value="all">
            <span class="crm-radio-custom"></span>
            Todas las fechas
          </label>
          <label class="crm-radio-label">
            <input type="radio" class="crm-radio" name="creationDateRange" [(ngModel)]="filters.creationDateRange" value="today">
            <span class="crm-radio-custom"></span>
            Hoy
          </label>
          <label class="crm-radio-label">
            <input type="radio" class="crm-radio" name="creationDateRange" [(ngModel)]="filters.creationDateRange" value="7d">
            <span class="crm-radio-custom"></span>
            Últimos 7 días
          </label>
          <label class="crm-radio-label">
            <input type="radio" class="crm-radio" name="creationDateRange" [(ngModel)]="filters.creationDateRange" value="30d">
            <span class="crm-radio-custom"></span>
            Últimos 30 días
          </label>
        </div>
      </div>

      <div class="filter-section">
        <label class="section-title">Cuentas con teléfono</label>
        <div class="options-row">
          <label class="crm-radio-label">
            <input type="radio" class="crm-radio" name="phoneFilter" [(ngModel)]="filters.phoneFilter" value="all">
            <span class="crm-radio-custom"></span>
            Todas las cuentas
          </label>
          <label class="crm-radio-label">
            <input type="radio" class="crm-radio" name="phoneFilter" [(ngModel)]="filters.phoneFilter" value="withPhone">
            <span class="crm-radio-custom"></span>
            Con teléfono
          </label>
          <label class="crm-radio-label">
            <input type="radio" class="crm-radio" name="phoneFilter" [(ngModel)]="filters.phoneFilter" value="withoutPhone">
            <span class="crm-radio-custom"></span>
            Sin teléfono
          </label>
        </div>
      </div>

      <hr style="margin-top: 24px;">

      <div class="filter-actions">
        <button type="button" class="btn btn-primary-outline" (click)="clearFilters()">Limpiar filtros</button>
        <button type="button" class="btn btn-primary" (click)="applyFilters()">Aplicar filtros</button>
      </div>
    </form>
  </div>
</div>